import React, { Component } from 'react';
import { arrowForwardOutline as forward } from 'ionicons/icons';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  withIonLifeCycle,
} from '@ionic/react';

import RentalPriceSummary from '../components/RentalPriceSummary';
import RentalDevicesService from '../services/rentalDevices';
import '../theme/service.css';

class RentalDeviceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      viewingCategory: null,
      loading: true,
    };

    this.selectCategory = this.selectCategory.bind(this);
    this.backToCategories = this.backToCategories.bind(this);
  }

  async ionViewWillEnter() {
    this.setState({ loading: true, viewingCategory: null });
    try {
      const { data: devices } = await RentalDevicesService.all();
      const categories = (devices.categories || []).filter(
        (category) => category.devices && category.devices.length > 0
      );

      this.setState({
        categories,
        viewingCategory: categories.length === 1 ? categories[0] : null,
        loading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  }

  selectCategory(category) {
    this.setState({ viewingCategory: category });
  }

  backToCategories() {
    this.setState({ viewingCategory: null });
  }

  goToDevice(deviceId) {
    this.props.history.push(`/app/rentals/${deviceId}`);
  }

  renderDeviceCard(device) {
    return (
      <IonCard key={device.id} className="service-card" onClick={() => this.goToDevice(device.id)}>
        <div className="service-card-image">
          {device.image_url ? (
            <img src={device.image_url} alt={device.name} />
          ) : (
            <div className="service-card-image-placeholder">
              <IonIcon icon={forward} />
            </div>
          )}
        </div>

        <IonCardHeader>
          <IonCardTitle>{device.name}</IonCardTitle>
        </IonCardHeader>

        <IonCardContent>
          {device.description && <p className="service-card-description">{device.description}</p>}

          {device.show_price !== false && (
            <p>
              <RentalPriceSummary device={device} emptyLabel="Prezzo non disponibile" />
            </p>
          )}

          <div className="service-card-footer">
            <IonButton
              className="service-card-button"
              fill="solid"
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                this.goToDevice(device.id);
              }}
            >
              Noleggia
            </IonButton>

            <IonIcon icon={forward} color="medium" />
          </div>
        </IonCardContent>
      </IonCard>
    );
  }

  render() {
    const { categories, viewingCategory, loading } = this.state;
    const singleCategory = categories.length === 1;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              {viewingCategory && !singleCategory ? (
                <IonButton onClick={this.backToCategories}>
                  <IonIcon icon={forward} style={{ transform: 'rotate(180deg)' }} />
                </IonButton>
              ) : (
                <IonBackButton defaultHref="/app/home" />
              )}
            </IonButtons>

            <IonTitle>{viewingCategory && !singleCategory ? viewingCategory.name : 'Noleggio Dispositivi'}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Caricamento...</p>
            </div>
          ) : categories.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Nessun dispositivo disponibile al momento.</p>
            </div>
          ) : viewingCategory ? (
            <div className="service-list-page">
              <div className="service-list-container">
                <IonCard className="service-list-header" color="light">
                  <IonCardHeader>
                    <IonCardTitle>{viewingCategory.name}</IonCardTitle>
                  </IonCardHeader>

                  <IonCardContent>
                    <p>
                      Ecco l'elenco dei dispositivi a noleggio,
                      <br />
                      seleziona il dispositivo che ti interessa
                    </p>
                  </IonCardContent>
                </IonCard>

                <div className="service-grid">
                  {viewingCategory.devices.map((device) => this.renderDeviceCard(device))}
                </div>
              </div>
            </div>
          ) : (
            <>
              <p className="ion-padding-top ion-padding-start ion-padding-end">
                Sfoglia l'elenco delle categorie <br /> e seleziona quella di tuo interesse per accedere ai relativi
                dispositivi.
              </p>

              <IonList lines="full" className="ion-no-margin ion-no-padding">
                <IonItem>Categorie</IonItem>
                {categories.map((category) => (
                  <IonItem key={category.id} onClick={() => this.selectCategory(category)}>
                    <IonLabel>{category.name}</IonLabel>
                    <IonIcon slot="end" icon={forward} />
                  </IonItem>
                ))}
              </IonList>
            </>
          )}
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(RentalDeviceList);
